import { createElement } from '@max/max';
import Image from '@max/leez-image';
import { _toPx } from '../../utils/style';
import { imageList } from '../../lib/constant';
import { CouponStatus } from '@nibfe/mkt-coupon-api';
const logoWidthConfig = {
    one: 88,
    two: 65,
    default: 57
};
const logoTopConfig = {
    one: 0,
    two: '22rpx',
    default: '53rpx'
};
export default function InflateLogo(props) {
    const { type = 'one', status } = props;
    const logoWidth = logoWidthConfig[type];
    return <Image x-if={status === CouponStatus.AfterInflate} width={_toPx(logoWidth)} widthAuto source={{
            uri: imageList.expandLogo[type]
        }} style={{
            position: 'absolute',
            right: 0,
            top: logoTopConfig[type]
        }} resizeMode="cover" placeholder={false}/>;
}
